<div class="page-list-container">
  <!-- <cdk-virtual-scroll-viewport itemSize="180" class="grid-viewport" #pageGridViewport> -->
  <ng-container *ngIf="isReady">
    <div class="w-100 mt-2 items">
      <div class="grid-item" *ngFor="let page of filePages.pages; trackBy: trackByPageId" (click)="selectPage(page)">
        <div class="d-flex align-items-center justify-content-center thumb-container">
          <img
            [src]="`${page.signedURL}?thumbnail=${page.transcodeMetadata[0]?.quality}`"
            [alt]="`Page ${page.rank}`"
            loading="lazy" />
        </div>

        <div class="px-2 d-flex align-items-center justify-content-between page-info">
          <span class="title">Page {{ page.rank }}</span>
          <div class="ms-auto d-flex align-items-center right-items">
            <div class="comment-count" *ngIf="hasCommentCount(page.id)">
              {{ commentCount[page.id] }}
            </div>
            <div
              class="page-menu-dropdown"
              ngbDropdown
              autoCloseDropdown
              container="body"
              [autoClose]="true"
              (click)="$event.stopImmediatePropagation()"
              dropdownClass="topic-option-dropdown">
              <div
                ngbDropdownToggle
                class="d-flex align-items-center justify-content-center p-1 edit-item"
                role="button">
                <svg width="3" height="10" fill="none">
                  <use xlink:href="/assets/img/selection-grid-edit/three-dot-ellipsis.svg#icon"></use>
                </svg>
              </div>
              <div ngbDropdownMenu>
                <button ngbDropdownItem class="w-100 d-inline-flex align-items-center btn" (click)="downloadPage(page)">
                  <i class="fa fa-download me-2" Òria-hidden="true"></i>
                  <span class="text-uppercase">{{ 'download' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isReady">
    <div
      class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
      <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
        <span>{{ 'asset_processingFile' | translate }}</span>
        <span>{{ 'asset_pleaseWait' | translate }}</span>
      </div>
    </div>
  </ng-container>

  <!-- </cdk-virtual-scroll-viewport> -->
</div>
